<template>
    <v-container fluid class="mt-3">
        <!-- Booking Closed disables every field in the form -->
        <v-form :disabled="locked" @submit.prevent>
        <!-- Row 1: Event Details + Late Fee & Financials -->
        <v-row class="mb-1">
            <!-- Card 1: Event Details -->
            <v-col cols="6">
                <v-card class="settings-card">
                    <div class="settings-card-header pa-4 d-flex align-center">
                        <v-icon color="white" size="16" class="mr-2">mdi-calendar-text-outline</v-icon>
                        <span>Event Details</span>
                    </div>
                    <v-card-text class="pa-5">
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="edit_event.name" outlined dense label="Event Name"
                                    type="text"></v-text-field>
                            </v-col>
                            <!-- <v-col cols="6">
                                <v-select v-model="edit_event.event_status" outlined dense label="Event Status"
                                    :items="['New', 'Pending', 'Active', 'Rush', 'Processing', 'Updated and Needs Action']"></v-select>
                            </v-col> -->
                            <v-col cols="6">
                                <v-dialog v-model="menu0" max-width="290px" min-width="290px" :disabled="locked">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formattedStartDate" label="Start Date" readonly
                                            v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-if="menu0" v-model="edit_event.start_date" full-width
                                        @change="menu0 = false"></v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="6">
                                <v-dialog v-model="menu1" max-width="290px" min-width="290px" :disabled="locked">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formattedPayDate" label="Pay By Date" readonly
                                            v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-if="menu1" v-model="edit_event.pay_date" full-width
                                        @change="menu1 = false"></v-date-picker>
                                </v-dialog>
                            </v-col>
                            <!-- <v-col cols="6">
                                <v-text-field v-model="edit_event.deposit_amount" outlined dense
                                    label="Deposit Required" type="text"></v-text-field>
                            </v-col> -->
                            <!-- <v-col cols="4">
                                <v-dialog v-model="menu2" max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formattedDepositDueDate" label="Deposit Due Date"
                                            readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-if="menu2" v-model="edit_event.deposit_due_date" full-width
                                        @change="menu2 = false"></v-date-picker>
                                </v-dialog>
                            </v-col> -->
                            <!-- <v-col cols="6">
                                <v-select v-model="edit_event.is_cancelled" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Event Cancelled"></v-select>
                            </v-col> -->
                            <v-col cols="6">
                                <v-select v-model="edit_event.free_stag_hen" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Free Stag/Hen"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="edit_event.bar_crawl" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Bar Crawl"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="edit_event.disable_org_itinerary" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Hide Organizer Itinerary"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="edit_event.itinerary_sent" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Itinerary Sent"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Card 2: Late Fee & Financials -->
            <v-col cols="6">
                <v-card class="settings-card">
                    <div class="settings-card-header pa-4 d-flex align-center">
                        <v-icon color="white" size="16" class="mr-2">mdi-currency-gbp</v-icon>
                        <span>Payment Details</span>
                    </div>
                    <v-card-text class="pa-5">
                        <v-row dense>
                            <v-col cols="6">
                                <v-select v-model="edit_event.disable_payment" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Disable Payment"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="edit_event.disable_payment_surcharge" :items="yesNoItems"
                                    item-text="text" item-value="value" outlined dense
                                    label="Disable Surcharge"></v-select>
                            </v-col>
                            <!-- <v-col cols="6">
                                <v-select v-model="edit_event.allow_org_deposit" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Allow Organizer Deposit"></v-select>
                            </v-col> -->
                            <v-col cols="6">
                                <v-select v-model="edit_event.disable_inv_deposit" :items="yesNoItems" item-text="text"
                                    item-value="value" outlined dense label="Disable Invitee Deposit"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="edit_event.cutoff_extension" outlined dense
                                    label="Deposit Cutoff Extension" type="text"></v-text-field>
                                <div v-if="depositCutoffDate && edit_event.disable_inv_deposit === 0"
                                    style="font-size: 13px; color: #555; margin-top: -8px;">
                                    Invitees can pay deposit up to <strong>{{ depositCutoffDate }}</strong>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="section-label mb-4">Admin and Late Fee</div>
                        <v-row>
                            <v-col cols="3">
                                <v-text-field v-model="edit_event.admin_fee" outlined dense label="Admin Fee"
                                    type="text"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="edit_event.late_fee_amount" label="Late Fee" outlined
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="edit_event.late_fee_days" label="Late Fee Days" outlined
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-select v-model="edit_event.late_fee_date_type" label="Late Fee Date Type"
                                    :items="['Event Date', 'Pay By Date']" outlined dense></v-select>
                            </v-col>
                        </v-row>
                        <div class="caption grey--text">Late fee is charged per invitee on full payments made within
                            Late Fee Days of the chosen date. Set Late Fee to 0 to turn it off for this event.</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        </v-form>

        <!-- Update button -->
        <v-row class="mt-3">
            <v-col cols="12">
                <div class="d-flex justify-end">
                    <v-btn :dark="!locked" :disabled="locked" class="custom-buttons" color="#3988AA"
                        @click="updateEvent()">
                        <v-icon small left>mdi-content-save-outline</v-icon>
                        Save Changes
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <SupplierChangesPrompt :changes="supplier_changes" :event="event" @close="supplier_changes = null" />
    </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import SupplierChangesPrompt from "./components/SupplierChangesPrompt.vue"
import { isBookingClosed } from "@/utils/eventStatus"

export default {
    components: {
        SupplierChangesPrompt,
    },
    data: () => ({
        page_name: "Event",
        menu0: false,
        menu1: false,
        menu2: false,
        supplier_changes: null,
        yesNoItems: [{ text: 'Yes', value: 1 }, { text: 'No', value: 0 }],
        edit_event: {
            id: null,
            name: null,
            start_date: null,
            reference_code: null,
            password: null,
            pay_date: null,
            deposit_amount: null,
            deposit_due_date: null,
            is_deposit_paid: null,
            is_fully_paid: null,
            supplier_paid: null,
            is_cancelled: null,
            // event_status is left out on purpose: it's changed on the Invitees tab and events list,
            // and this copy is only loaded on mount, so saving it here could undo a status change.
            admin_fee: null,
            cutoff_extension: null,
            disable_payment: null,
            allow_org_deposit: null,
            disable_inv_deposit: null,
            free_stag_hen: null,
            bar_crawl: null,
            late_fee_amount: null,
            late_fee_days: null,
            late_fee_date_type: null,
            disable_payment_surcharge: 0,
            disable_org_itinerary: 0,
            itinerary_sent: 0
        },
        classes: {
        },
    }),
    created() {
    },
    async mounted() {
        this.setData()
    },
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
            event: 'eventsStore/getSelectedEventGetter',
        }),
        locked() {
            return isBookingClosed(this.event)
        },
        formattedDepositDueDate: {
            get() {
                return this.edit_event.deposit_due_date
                    ? this.$date(this.edit_event.deposit_due_date).format('DD/MM/YYYY')
                    : ''
            },
            set(val) {
                this.edit_event.deposit_due_date = val
            }
        },
        formattedPayDate: {
            get() {
                return this.edit_event.pay_date
                    ? this.$date(this.edit_event.pay_date).format('DD/MM/YYYY')
                    : ''
            },
            set(val) {
                this.edit_event.pay_date = val
            }
        },
        formattedStartDate: {
            get() {
                return this.edit_event.start_date
                    ? this.$date(this.edit_event.start_date).format('DD/MM/YYYY')
                    : ''
            },
            set(val) {
                this.edit_event.start_date = val
            }
        },
        depositCutoffDate() {
            const lead = this.event?.lead
            if (!lead?.payments?.length) return null
            const depositPayment = lead.payments.find(p => p.payment_date)
            if (!depositPayment?.payment_date) return null
            const base = new Date(depositPayment.payment_date)
            const extension = parseInt(this.event.cutoff_extension ?? 0) || 0
            base.setDate(base.getDate() + 21 + extension)
            return base.toLocaleDateString('en-IE', { day: 'numeric', month: 'long', year: 'numeric' })
        }
    },
    methods: {
        setData() {
            this.edit_event.id = this.event.id
            this.edit_event.name = this.event.name
            this.edit_event.reference_code = this.event.reference_code
            this.edit_event.password = this.event.password
            this.edit_event.pay_date = this.event.pay_date
            this.edit_event.deposit_amount = this.event.deposit_amount
            this.edit_event.deposit_due_date = this.event.deposit_due_date
            this.edit_event.is_deposit_paid = this.event.is_deposit_paid
            this.edit_event.is_fully_paid = this.event.is_fully_paid
            this.edit_event.supplier_paid = this.event.supplier_paid
            this.edit_event.is_cancelled = this.event.is_cancelled
            this.edit_event.admin_fee = this.event.admin_fee
            this.edit_event.cutoff_extension = this.event.cutoff_extension
            this.edit_event.disable_payment = this.event.disable_payment
            this.edit_event.allow_org_deposit = this.event.allow_org_deposit
            this.edit_event.disable_inv_deposit = this.event.disable_inv_deposit
            this.edit_event.free_stag_hen = this.event.free_stag_hen
            this.edit_event.bar_crawl = this.event.bar_crawl
            this.edit_event.late_fee_amount = this.event.late_fee_amount
            this.edit_event.late_fee_days = this.event.late_fee_days
            this.edit_event.late_fee_date_type = this.event.late_fee_date_type
            this.edit_event.disable_payment_surcharge = this.event.disable_payment_surcharge
            this.edit_event.disable_org_itinerary = this.event.disable_org_itinerary
            this.edit_event.itinerary_sent = this.event.itinerary_sent
            this.edit_event.start_date = this.event?.lead?.start_date ?? null
        },
        async updateEvent() {
            const { start_date, ...event_fields } = this.edit_event
            let payload = {
                company_id: this.get_selected_company.id,
                ...event_fields
            }
            const originalStartDate = this.event?.lead?.start_date ?? null
            const startDateChanged = start_date && start_date !== originalStartDate

            const response = await this.$axios.post(`admin/events/update_event/${payload.id}`, payload)
            const result = response.data
            if (result.response == true) {
                if (startDateChanged) {
                    const lead = this.event.lead
                    const leadResponse = await this.$axios.post(`admin/leads/update_lead/${lead.id}`, {
                        ...lead,
                        company_id: this.get_selected_company.id,
                        start_date: start_date,
                    })
                    if (leadResponse.data?.pay_date) {
                        this.edit_event.pay_date = leadResponse.data.pay_date
                    }
                    // Booked suppliers: offer them a dates changed email.
                    this.supplier_changes = leadResponse.data?.supplier_changes || null
                }
                this.$toast.success(result.message)
                this.$emit('refresh')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.settings-card {
    border-radius: 10px !important;
    overflow: hidden;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 5px 5px 13px 0px rgba(240, 240, 240, 0.90), -5px -5px 10px 0px rgba(255, 255, 255, 0.90) !important;
    height: 100%;
}

.settings-card-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
    font-family: Manrope;
    font-size: 13px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.custom-small {
    color: #7C7C7C;
    font-size: 12px;
    font-weight: 600;
}

:deep(.theme--light.v-data-table tbody td) {
    height: 80px;
    border: none;
}

.label-text-color {
    color: #7C7C7C;
}

.text-proper-case {
    text-transform: capitalize;
}

.search-text-field {
    margin-top: 15px;

    .v-input__slot {
        min-height: 0 !important;
        margin-top: 8px;
    }

    .v-input__prepend-inner {
        margin-top: 5px !important;
    }
}

:deep(.custom-buttons span) {
    text-transform: none;
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.section-label {
    font-size: 11px;
    font-weight: 700;
    color: #9E9E9E;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 10px;
}

.paid_row {
    background-color: #FFF1F1 !important;
}


:deep(.custom-text-field) {
    legend {
        display: none;
    }

    fieldset {
        border-color: #D3D3D3 !important;
    }

    input {
        color: #101010;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
}
</style>